import React, { useCallback, useEffect, useState } from 'react';
import { apiFetch } from '../lib/apiFetch';
import { ApiResponse, Cliente } from '../types';
import { VistaLlamadasVenta } from './VistaLlamadasVenta';
import { PanelDatosAnalisis } from './PanelDatosAnalisis';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

type SubTab = 'llamadas' | 'datos';

// Ambas mitades del módulo 'ventas' (coach de llamadas y analista de datos)
// comparten esta pestaña de nivel superior, con sub-navegación acá adentro
// en vez de dos entradas separadas en el menú principal.
export const VistaVentas: React.FC = () => {
    const [subTab, setSubTab] = useState<SubTab>('llamadas');
    const [clientes, setClientes] = useState<Cliente[]>([]);

    const fetchClientes = useCallback(async () => {
        try {
            const res = await apiFetch(`${API_BASE}/clientes`);
            const json: ApiResponse<Cliente[]> = await res.json();
            if (json.success && json.data) setClientes(json.data);
        } catch (e) {
            console.error(e);
        }
    }, []);

    useEffect(() => { fetchClientes(); }, [fetchClientes]);

    return (
        <div className="space-y-4">
            <div className="flex gap-1 border-b border-slate-200">
                <button
                    onClick={() => setSubTab('llamadas')}
                    className={`px-3 py-2 text-sm font-medium border-b-2 -mb-px ${
                        subTab === 'llamadas' ? 'border-slate-800 text-slate-800' : 'border-transparent text-slate-500 hover:text-slate-600'
                    }`}
                >
                    📞 Coach de Llamadas
                </button>
                <button
                    onClick={() => setSubTab('datos')}
                    className={`px-3 py-2 text-sm font-medium border-b-2 -mb-px ${
                        subTab === 'datos' ? 'border-slate-800 text-slate-800' : 'border-transparent text-slate-500 hover:text-slate-600'
                    }`}
                >
                    📊 Analista de Datos
                </button>
            </div>

            {subTab === 'llamadas' && <VistaLlamadasVenta />}
            {subTab === 'datos' && <PanelDatosAnalisis clientes={clientes} />}
        </div>
    );
};
